import { render, staticRenderFns } from "./VaccinationPrintCard.vue?vue&type=template&id=212d0b68&"
import script from "./VaccinationPrintCard.vue?vue&type=script&lang=js&"
export * from "./VaccinationPrintCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports